export enum ETabsActions {
  SET_ACTIVE_TAB = 'tabs/setActiveTab',
}
